import styled from 'styled-components';

export default styled.section`
	display: flex;
	width: 100%;
	margin-bottom: var(--px-16);
	&:last-child {
		margin-bottom: 0 !important;
	}
	.StyledListHeader {
		min-height: var(--px-134) !important;
	}
	.openAnalyticDocumentation {
		border-top: var(--px-1) solid var(--neutrals-300);
		margin-top: var(--px-16);
		padding-top: var(--px-16);
		display: flex;
		align-items: center;
		width: 100%;
		.motif-icon {
			display: inline-flex;
			align-items: center;
			svg {
				width: var(--px-16) !important;
				height: var(--px-16) !important;
				fill: var(--blue-600);
				path {
					fill: var(--blue-600);
				}
			}
		}
		.openAnalyticDocumentationLabel {
			margin-left: var(--px-3);
			font-size: var(--px-14);
			font-weight: 700;
			color: var(--blue-600);
			display: inline-flex;
		}
	}
	.tooltiplabel {
		display: inline-flex;
		&.showTxt {
			cursor: pointer;
			font-size: var(--px-14);
			font-weight: 700;
			line-height: var(--px-22);
			color: var(--blue-600);
		}
	}
	.styledAccountName {
		width: auto;
		max-width: 100%;
		.ellipses {
			width: auto;
		}
	}
`;